module.exports = __webpack_public_path__ + "img/industrial.bb82d7ae.png";